import React from 'react';
import AdherenceSettingsCohortsInactiveDaysTable from 'components/molecules/adherence-settings/cohorts-inactive-days';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

const AdherenceSettingsCohortsInactiveDaysPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <h1 className={s.title}>{t('links.cohortsInactiveDays')}</h1>
      <AdherenceSettingsCohortsInactiveDaysTable />
    </div>
  );
};

export default AdherenceSettingsCohortsInactiveDaysPage;
